import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_4 = { class: "mb-4 w-2/5" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_7 = { class: "mb-4 w-2/5" }
const _hoisted_8 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_9 = { class: "mb-4 w-2/5" }
const _hoisted_10 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_11 = { class: "mb-4 w-2/5" }
const _hoisted_12 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_13 = { class: "mb-4 w-2/5" }
const _hoisted_14 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_15 = { class: "mb-8 w-2/5" }
const _hoisted_16 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_17 = { class: "font-bold font-size-18 mb-1" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "w-2/5 mr-4" }
const _hoisted_23 = { class: "w-32" }
const _hoisted_24 = { class: "text-base ml-2" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = { class: "w-2/5 mr-4" }
const _hoisted_29 = { class: "w-32" }
const _hoisted_30 = { class: "text-base ml-2" }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "w-2/5 mr-4" }
const _hoisted_35 = { class: "w-32" }
const _hoisted_36 = { class: "text-base ml-2" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_39 = { class: "flex items-center" }
const _hoisted_40 = { class: "w-2/5 mr-4" }
const _hoisted_41 = { class: "w-32" }
const _hoisted_42 = { class: "text-base ml-2" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_45 = { class: "flex items-center" }
const _hoisted_46 = { class: "w-2/5 mr-4" }
const _hoisted_47 = { class: "w-32" }
const _hoisted_48 = { class: "text-base ml-2" }
const _hoisted_49 = { class: "mb-8" }
const _hoisted_50 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_51 = { class: "flex items-center" }
const _hoisted_52 = { class: "w-2/5 mr-4" }
const _hoisted_53 = { class: "w-32" }
const _hoisted_54 = { class: "text-base ml-2" }
const _hoisted_55 = { class: "font-bold font-size-18 mb-1" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_57 = { class: "mb-4" }
const _hoisted_58 = { class: "font-bold font-size-14" }
const _hoisted_59 = { class: "w-2/5" }
const _hoisted_60 = { class: "bg-blue-pale rounded w-fit" }
const _hoisted_61 = { class: "mb-4" }
const _hoisted_62 = { class: "font-bold font-size-14" }
const _hoisted_63 = { class: "w-3/5" }
const _hoisted_64 = {
  key: 0,
  class: "flex mt-2 ml-6"
}
const _hoisted_65 = { class: "mr-2 flex" }
const _hoisted_66 = { class: "ml-2" }
const _hoisted_67 = { class: "mt-3 mr-2" }
const _hoisted_68 = { class: "ml-2 mt-3" }
const _hoisted_69 = { class: "bg-blue-pale rounded w-fit" }
const _hoisted_70 = { class: "font-size-14 font-bold" }
const _hoisted_71 = { class: "w-2/5" }
const _hoisted_72 = {
  key: 0,
  class: "ml-6"
}
const _hoisted_73 = { class: "mt-4" }
const _hoisted_74 = { class: "flex items-center" }
const _hoisted_75 = { class: "mr-4 font-bold font-size-14" }
const _hoisted_76 = { class: "w-28 mr-2" }
const _hoisted_77 = { class: "mt-4" }
const _hoisted_78 = { class: "font-bold font-size-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Select = _resolveComponent("Select")
  const _component_Input = _resolveComponent("Input")
  const _component_RadioInputGroup = _resolveComponent("RadioInputGroup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('beingLateTime.roundingSetting')) + "：" + _toDisplayString(_ctx.t('beingLateTime.seconds')), 1),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('beingLateTime.attendanceStamp')), 1)
      ]),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.wayRoundSecondCheckinList,
        modelValue: _ctx.workingStyleMasterParams.way_rounding_seconds_checkin,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_seconds_checkin = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t('beingLateTime.leaveWorkStamp')), 1),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.wayRoundSecondCheckoutList,
        modelValue: _ctx.workingStyleMasterParams.way_rounding_seconds_checkout,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_seconds_checkout = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('breakStartTime')), 1),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.wayRoundSecondBreakStartList,
        modelValue: _ctx.workingStyleMasterParams.way_rounding_seconds_break_start,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_seconds_break_start = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('breakEndTime')), 1),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.wayRoundSecondBreakEndList,
        modelValue: _ctx.workingStyleMasterParams.way_rounding_seconds_break_end,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_seconds_break_end = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.t('goOutAndStartEngraving')), 1),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.optionsRadioDefault,
        modelValue: _ctx.workingStyleMasterParams.way_rounding_seconds_go_out_start,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_seconds_go_out_start = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('goBackStamping')), 1),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.optionsRadioDefault,
        modelValue: _ctx.workingStyleMasterParams.way_rounding_seconds_go_out_end,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_seconds_go_out_end = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('beingLateTime.roundingSetting')) + "：" + _toDisplayString(_ctx.t('beingLateTime.minutesTitle')), 1),
    _hoisted_18,
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('beingLateTime.attendanceStamp')), 1),
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.wayRoundMinuteCheckinList,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_minute_checkin,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_minute_checkin = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_23, [
          _createVNode(_component_Select, {
            optionsSelect: _ctx.optionsRoundingMinutes,
            "model-value": "1",
            modelValue: _ctx.workingStyleMasterParams.minute_rounding_checkin,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.workingStyleMasterParams.minute_rounding_checkin = $event))
          }, null, 8, ["optionsSelect", "modelValue"])
        ]),
        _createVNode("div", _hoisted_24, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, _toDisplayString(_ctx.t('beingLateTime.leaveWorkStamp')), 1),
      _createVNode("div", _hoisted_27, [
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.wayRoundMinuteCheckoutList,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_minute_checkout,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_minute_checkout = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode(_component_Select, {
            optionsSelect: _ctx.optionsRoundingMinutes,
            modelValue: _ctx.workingStyleMasterParams.minute_rounding_checkout,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.workingStyleMasterParams.minute_rounding_checkout = $event))
          }, null, 8, ["optionsSelect", "modelValue"])
        ]),
        _createVNode("div", _hoisted_30, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_31, [
      _createVNode("div", _hoisted_32, _toDisplayString(_ctx.t('dailyAttendanceHeaders.breakStartTimeRounding')), 1),
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.wayRoundMinuteBreakStartList,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_minute_break_start,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_minute_break_start = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode(_component_Select, {
            optionsSelect: _ctx.optionsRoundingMinutes,
            "model-value": "1",
            modelValue: _ctx.workingStyleMasterParams.minute_rounding_break_start,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.workingStyleMasterParams.minute_rounding_break_start = $event))
          }, null, 8, ["optionsSelect", "modelValue"])
        ]),
        _createVNode("div", _hoisted_36, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", _hoisted_38, _toDisplayString(_ctx.t('dailyAttendanceHeaders.breakEndTime')), 1),
      _createVNode("div", _hoisted_39, [
        _createVNode("div", _hoisted_40, [
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.wayRoundMinuteBreakEndList,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_minute_break_end,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_minute_break_end = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_41, [
          _createVNode(_component_Select, {
            optionsSelect: _ctx.optionsRoundingMinutes,
            modelValue: _ctx.workingStyleMasterParams.minute_rounding_break_end,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.workingStyleMasterParams.minute_rounding_break_end = $event))
          }, null, 8, ["optionsSelect", "modelValue"])
        ]),
        _createVNode("div", _hoisted_42, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_43, [
      _createVNode("div", _hoisted_44, _toDisplayString(_ctx.t('startOut')), 1),
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.optionsRadioDefaultCustom,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_minute_go_out_start,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_minute_go_out_start = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_47, [
          _createVNode(_component_Select, {
            optionsSelect: _ctx.optionsRoundingMinutes,
            modelValue: _ctx.workingStyleMasterParams.minute_rounding_go_out_start,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.workingStyleMasterParams.minute_rounding_go_out_start = $event))
          }, null, 8, ["optionsSelect", "modelValue"])
        ]),
        _createVNode("div", _hoisted_48, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_49, [
      _createVNode("div", _hoisted_50, _toDisplayString(_ctx.t('goBackStamping')), 1),
      _createVNode("div", _hoisted_51, [
        _createVNode("div", _hoisted_52, [
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.optionsRadioDefaultCustom,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_minute_go_out_end,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_minute_go_out_end = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_53, [
          _createVNode(_component_Select, {
            optionsSelect: _ctx.optionsRoundingMinutes,
            modelValue: _ctx.workingStyleMasterParams.minute_rounding_go_out_end,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.workingStyleMasterParams.minute_rounding_go_out_end = $event))
          }, null, 8, ["optionsSelect", "modelValue"])
        ]),
        _createVNode("div", _hoisted_54, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_55, _toDisplayString(_ctx.t('beingLateTime.roundingForWorkSchedule')) + "（" + _toDisplayString(_ctx.t('roundingOfActualTime')) + "） ", 1),
    _hoisted_56,
    _createVNode("div", _hoisted_57, [
      _createVNode("div", _hoisted_58, _toDisplayString(_ctx.t('beingLateTime.fixCommutingTime')), 1),
      _createVNode("div", _hoisted_59, [
        _createVNode(_component_RadioGroup, {
          optionsRadio: _ctx.optionsRadioFixCommutingOption,
          modelValue: _ctx.workingStyleMasterParams.is_fix_checkin_to_start_shift,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.workingStyleMasterParams.is_fix_checkin_to_start_shift = $event))
        }, null, 8, ["optionsRadio", "modelValue"])
      ]),
      _createVNode("div", _hoisted_60, _toDisplayString(_ctx.t('beingLateTime.ifYouSelectFix')), 1)
    ]),
    _createVNode("div", _hoisted_61, [
      _createVNode("div", _hoisted_62, _toDisplayString(_ctx.t('beingLateTime.fixLeaveTime')), 1),
      _createVNode("div", _hoisted_63, [
        _createVNode(_component_RadioGroup, {
          optionsRadio: _ctx.optionsRadioFixLeaveTime,
          modelValue: _ctx.workingStyleMasterParams.fix_checkout_to_end_shift,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.workingStyleMasterParams.fix_checkout_to_end_shift = $event))
        }, null, 8, ["optionsRadio", "modelValue"])
      ]),
      (
          _ctx.workingStyleMasterParams.fix_checkout_to_end_shift ===
          _ctx.FIX_CHECKOUT_TO_END_SHIFT_TYPE.ROUND_UP_TIME
        )
        ? (_openBlock(), _createBlock("div", _hoisted_64, [
            _createVNode("div", _hoisted_65, [
              _createVNode(_component_Input, {
                class: "mr-2 w-24",
                width: "80px",
                modelValue: _ctx.workingStyleMasterParams.hours_to_rounding,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.workingStyleMasterParams.hours_to_rounding = $event)),
                validated: _ctx.validated,
                "error-server": _ctx.errorServer.hours_to_rounding
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_66, _toDisplayString(_ctx.t('beingLateTime.roundToLessMinutes')), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "validated", "error-server"]),
              _createVNode("div", _hoisted_67, _toDisplayString(_ctx.t('time2')), 1),
              _createVNode(_component_Input, {
                class: "w-24",
                width: "80px",
                modelValue: _ctx.workingStyleMasterParams.minutes_to_rounding,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.workingStyleMasterParams.minutes_to_rounding = $event)),
                validated: _ctx.validated,
                "error-server": _ctx.errorServer.minutes_to_rounding
              }, null, 8, ["modelValue", "validated", "error-server"]),
              _createVNode("div", _hoisted_68, _toDisplayString(_ctx.t('beingLateTime.unitMinuties')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_69, [
        _createVNode("div", null, _toDisplayString(_ctx.t('fixedCheckoutNote')), 1)
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_70, _toDisplayString(_ctx.t('roundingOfMonthlyAggregation')), 1),
      _createVNode("div", _hoisted_71, [
        _createVNode(_component_RadioGroup, {
          optionsRadio: _ctx.roundingOfMonthlyAggregationOption,
          modelValue: _ctx.workingStyleMasterParams.is_rounding_of_aggregation_time,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.workingStyleMasterParams.is_rounding_of_aggregation_time = $event))
        }, null, 8, ["optionsRadio", "modelValue"])
      ]),
      (
          _ctx.workingStyleMasterParams.is_rounding_of_aggregation_time ===
          _ctx.ROUNDING_OF_AGGREGATION_TIME_TYPE.ROUND
        )
        ? (_openBlock(), _createBlock("div", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _createVNode("div", _hoisted_74, [
                _createVNode("div", _hoisted_75, _toDisplayString(_ctx.t('achievementRoundingUnit')), 1),
                _createVNode("div", _hoisted_76, [
                  _createVNode(_component_Select, {
                    disabled: 
                  _ctx.workingStyleMasterParams.achievement_rounding ===
                  _ctx.ACHIEVEMENT_ROUNDING_TYPE.ROUNDING
                ,
                    "options-select": _ctx.achievementRoundingUnitOption,
                    modelValue: 
                  _ctx.workingStyleMasterParams.achievement_rounding_unit_minutes
                ,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (
                  _ctx.workingStyleMasterParams.achievement_rounding_unit_minutes
                 = $event))
                  }, null, 8, ["disabled", "options-select", "modelValue"])
                ]),
                _createVNode("div", null, _toDisplayString(_ctx.t('minute')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_77, [
              _createVNode("div", _hoisted_78, _toDisplayString(_ctx.t('achievementRounding')), 1),
              _createVNode(_component_RadioInputGroup, {
                class: "ml-2",
                "options-radio": _ctx.achievementRoundingList,
                modelValue: _ctx.workingStyleMasterParams.achievement_rounding,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.workingStyleMasterParams.achievement_rounding = $event))
              }, null, 8, ["options-radio", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}